// 파티 판 동료 렌더(레인 D, docs/PARTY-TRADE-PRD.md 3장): MMO 필드의 다른 플레이어 렌더(PeersVisual — 카엘 GPU 스키닝 인스턴스 + 이름표)를
// 던전 장면에서도 쓴다. view.party.peers(PartyLink.frame이 채운 보간 구간)를 performance.now 시계로 샘플한다(PartyClient와 같은 시계).
// 파티 판에서만 보이고, 영웅 모델 GLB는 처음 판이 열릴 때 한 번 읽는다. 프레임 경로에서 새 객체를 만들지 않는다.
import * as THREE from 'three/webgpu';
import type { GameView } from '../../shared/types';
import { PeersVisual } from './peers';

export class PartyPeersRender {
  readonly group = new THREE.Group();
  readonly peers = new PeersVisual();
  private loading = false;

  constructor(private readonly now: () => number = () => performance.now()) {
    this.group.name = 'party-peers';
    this.group.visible = false;
    this.group.add(this.peers.group);
  }

  get drawn(): number { return this.peers.drawn; }

  update(view: GameView): void {
    const pv = view.party;
    const on = !!pv && pv.active;
    this.group.visible = on;
    if (!on) return;
    if (!this.loading) { this.loading = true; void this.peers.load(); }
    this.peers.update(pv.peers, this.now());
  }

  dispose(): void { this.peers.dispose(); }
}
